export const COPYRIGHT_TYPE = {
  WORD: 'WORD',
  MUSIC: 'MUSIC',
  TRACK: 'TRACK',
}

const Unf = undefined

export class CopyrightFormModal {
  constructor(type) {
    this.create(type)
  }

  create(type) {
    let baseForm = this.createBaseForm()

    if (type === COPYRIGHT_TYPE.MUSIC || COPYRIGHT_TYPE.WORD) {
      baseForm = {
        ...baseForm,
        cpPercent: 0,
        contractType: Unf,
        canCover: 0
      }
    }

    return baseForm
  }

  createBaseForm() {
    return {
      contract: '',
      canAuth: 0,
      licenseValid: 0,

      cpSource: Unf,
      isOverseaOnly: 0,

      canLegalRights: 0,
      copyrightArea: 0,

      copyrightFrom: 0,
      copyrightTo: 0,
    }
  }
}
